import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Tag } from "antd";

export default function Location({ latitude, longitude }) {
  if (!latitude || !longitude) return null;

  return (
    <Tag style={{ color: "gray" }} icon={<EnvironmentOutlined />}>
      {`${latitude.toFixed(2)}, ${longitude.toFixed(2)}`}
    </Tag>
  );
}
